import type { WynikOceny } from "@shared/ocenaSlowna.js";
import { etykietaOceny, tonOceny } from "../../lib/wynikUzytkownika.js";
import type { WariantBadge } from "../ui/Badge.js";

/**
 * Plakietka oceny slownej: "Bardzo dobrze", "Dobrze", "Średnio", "Słabo" albo neutralne "Za mało danych".
 *
 * To badge z warstwy prymitywow w wariantach oceny (BD-1: pigulka z tintem, obrysem i tekstem, tu na tokenach
 * --ocena-*; BD-2: neutralny), w dwoch rozmiarach: mala w wierszach parametrow, duza (`duza`) jako ocena ogolna na gorze
 * karty. Kolor wynika z oceny (tonOceny: zloto przy "Bardzo dobrze" i "Dobrze", szarosc przy "Słabo", bez oznaczenia przy
 * "Średnio"), ale nigdy nie niesie znaczenia sam: zawsze jest slowo (ST-3, A-7). Zlota i szara maja tez kropke, jak
 * plakietki w treningu: szary tint jest bardzo blisko neutralnego, wiec "Słabo" od "Średnio" odroznia tez ksztalt, nie
 * tylko slowo. "Za mało danych" jest neutralne, bo brak danych nie jest ani dobrym, ani zlym wynikiem. Wyjasnienie
 * ("x z y potrzebnych uwag") NIE siedzi w dymku: plakietka nie jest fokusowalna, wiec z klawiatury i z dotyku dymka nie
 * da sie wywolac. Stoi widocznie obok: przy ocenie ogolnej w karcie, przy parametrze w jego wierszu (KartaOceny).
 */
export function PlakietkaOceny({ wynik, duza = false }: { wynik: WynikOceny; duza?: boolean }): React.JSX.Element {
  // Ton to wariant prymitywu Badge (te same reguly CSS .badge[data-variant]): typ pilnuje, ze taki wariant istnieje.
  const ton: WariantBadge = tonOceny(wynik);
  const neutralna = ton === "neutralny";
  return (
    <span
      className={`badge${neutralna ? " badge--neutral" : ""}${duza ? " wynik-ocena--duza" : ""}`}
      data-variant={neutralna ? undefined : ton}
    >
      {/* Ta sama kropka co w prymitywie Badge (kolor z --badge-dot wariantu). */}
      {!neutralna && <span className="badge__dot" aria-hidden="true" />}
      {etykietaOceny(wynik)}
    </span>
  );
}
